import { recieveTagRules } from "./reducer";
import { APIClient } from "../../../helpers/api_helper";
const api = new APIClient();

export const loadTagRules = () => async (dispatch, getState) => {

    try {
        // Unpaginated, already filtered to is_active and ordered by
        // (priority, id) -- the drawer matcher walks the array as-is.
        const data = await api.get('/api/tag_rules/get_options/')

        if (data) {
            dispatch(recieveTagRules(data));
        }
    } catch (error) {
        console.error('Unable to load tag rules!', error)
    }
};
